/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Sort_OrderInputs */

const vi_shop_group_sort_order = /** @type {(inputs: Shop_Group_Sort_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thứ tự trong danh mục`)
};

/**

* @param {Shop_Group_Sort_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_sort_order = /** @type {((inputs?: Shop_Group_Sort_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Sort_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_sort_order(inputs)
});